const pt = {
  nav: {
    home: 'Início',
    blog: 'Blog',
    resume: 'Currículo',
  },
  lang: {
    en: 'EN',
    pt: 'PT',
    fr: 'FR',
  },
  jobTitle: 'Engenheiro de Software Full-Stack & Arquiteto',
  home: {
    available: 'Disponível para novas oportunidades',
    headline1: 'Olá, eu sou o',
    heroPart1: 'Eu adoro criar ',
    descriptionBold: 'soluções escaláveis, otimizadas e de alto desempenho',
    heroPart2: ' para empresas e compartilhar conhecimento através da escrita.',
    badge1: 'Especialista .NET',
    badge2: 'Full Stack',
    ctaBlog: 'Ler meu blog',
    ctaResume: 'Ver currículo',
    findMeOn: 'Me encontre em:',
    whatIDo: {
      title: 'O Que Faço',
      subtitle: 'Especializado em criar aplicações robustas e escaláveis em toda a stack',
      cards: [
        {
          icon: '🏗️',
          title: 'Arquitetura de Sistemas',
          description: 'Design de microsserviços, APIs e sistemas distribuídos que escalam.',
        },
        {
          icon: '💻',
          title: 'Desenvolvimento Full-Stack',
          description: 'Construção de soluções completas com .NET, React, Flutter e tecnologias cloud.',
        },
        {
          icon: '✍️',
          title: 'Escrita Técnica',
          description: 'Compartilhando conhecimento sobre padrões de design, boas práticas e cultura de engenharia.',
        },
      ],
    },
  },
  resume: {
    relevantExperience: 'Experiência Relevante',
    lastExperience: 'Última Experiência',
    skills: 'Habilidades',
    education: 'Educação',
    languages: 'Idiomas',
    selectedProjects: 'Projetos Selecionados',
  },
  footer: {
    rights: 'Todos os direitos reservados.',
    builtWith: 'Feito com React & ❤️',
  },
  blog: {
    featuredTitle: 'Artigos Recentes',
    featuredSubtitle: 'Reflexões sobre engenharia e arquitetura',
    viewAll: 'Ver todos',
    viewAllArticles: 'Ver todos os artigos',
    readMore: 'Ler mais',
    backToBlog: 'Voltar ao Blog',
    backToHome: 'Início',
    minuteRead: 'min de leitura',
    searchPlaceholder: 'Pesquisar artigos...',
    all: 'Todos',
    noPostsFound: 'Nenhum artigo encontrado',
    noPostsSubtitle: 'Tente ajustar os termos da pesquisa',
    noPostsAvailable: 'Nenhum artigo disponível ainda.',
    clearFilters: 'Limpar filtros',
    article: 'artigo',
    articles: 'artigos',
    failedToLoad: 'Falha ao carregar artigos do blog.',
    tryAgain: 'Tentar Novamente',
    featured: 'Destaque',
    backToTop: 'Início',
    relatedArticles: 'Artigos Relacionados',
    categories: {
      'design-patterns': 'Padrões de Projeto',
      'system-architecture': 'Arquitetura de Sistemas',
      'frontend-patterns': 'Padrões de Frontend',
      'tooling': 'Ferramentas',
      'best-practices': 'Boas Práticas',
    },
  },
};

export default pt;
